import axios from 'axios'
import router from '@/router'
import { useUserStore } from '@/store/user'
import store from '@/store'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

// Main list requests opt in to the permission declared by the active route.
// Keeping this separate from `get` prevents auxiliary requests on the same page
// (filters, dropdowns, details, etc.) from receiving an unrelated permission.
instance.getMainList = (url, config = {}) => {
    const permission = router.currentRoute.value.meta?.permission
    const headers = {...config.headers}

    if (permission) {
        headers['X-Check-Permissions'] = permission
    }

    return instance.get(url, {...config, headers})
}

instance.postMain = (url, data, config = {}) => {
    const permission = router.currentRoute.value.meta?.permission
    const headers = {...config.headers}

    if (permission) {
        headers['X-Check-Permissions'] = permission
    }

    return instance.post(url, data, {...config, headers})
}

let isLoggingOut = false
let isForbidden = false   // فلگ جدید برای 403

// جلوگیری از ارسال درخواست‌های جدید وقتی 403 رخ داده
instance.interceptors.request.use(
    config => {
        if (isForbidden) {
            return Promise.reject(new Error('Forbidden - redirecting to 403 page'))
        }

        return config
    },
    error => Promise.reject(error)
)

instance.interceptors.response.use(
    response => response,

    async error => {
        const status = error?.response?.status

        switch (status) {
            case 401:
                // اگه توکن نداریم یعنی کاربر لاگین نکرده، این 401 طبیعیه، logout نکن
                if (!localStorage.getItem('token')) {
                    return Promise.reject(error)
                }

                if (isLoggingOut || isForbidden) {
                    return Promise.reject(error)
                }

                isLoggingOut = true

                try {
                    console.log('logout')
                     /*const token = localStorage.getItem('token')
                     console.log('axios.jsssss')

                     if (token) {
                         await axios.post(
                             `${window.appConfig.API_URL_BASE}api/logout`,
                             {},
                             {
                                 headers: {
                                     Accept: 'application/json',
                                     'Content-Type': 'application/json',
                                     Authorization: `Bearer ${token}`,
                                 },
                             }
                         )
                     }*/
                } catch (err) {
                    console.error('Logout API Error:', err)
                } finally {
                    console.log('finally')
                    localStorage.removeItem('token')
                    localStorage.removeItem('panel-role')

                    store.commit('setMobile', '')
                    store.commit('setLogin', false)

                    const userStore = useUserStore()
                    userStore.clearUser()

                    if (router.currentRoute.value.path !== '/auth/login') {
                      await router.replace('/auth/login')
                    }

                    isLoggingOut = false
                }

                return Promise.reject(error)

            case 403:

                if (isForbidden) {
                    return Promise.reject(error)
                }

                isForbidden = true

                if (router.currentRoute.value.name !== 'Error403') {
                    await router.replace({ name: 'Error403' })
                }

                return Promise.reject(error)

            case 503:
                if (router.currentRoute.value.name !== 'Error503') {
                    await router.replace({ name: 'Error503' })
                }
                return Promise.reject(error)

            default:
                return Promise.reject(error)
        }
    }
)

export default instance
